import { get_api_path } from "services/api";
import { getBinaryFromFile } from "utils/fileUtils";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("student/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(student_id) {
  const url = get_api_path("student/detail", {}, { student_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(student_id) {
  const url = get_api_path("student/delete", {}, { student_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(student_id, data) {
  const url = get_api_path("student/update", {}, { student_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("student/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function schedule(student_id, { query }) {
  const url = get_api_path("student/schedule", query, { student_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function image(student_id, file) {
  const headers = { 'X-Name': file.name, 'Content-Type' : file.type };
  const data = await getBinaryFromFile(file);
  const url = get_api_path("student/image", {}, { student_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data, { headers });
  const { model } = response.data.result;
  return { model };
};

export async function mastery({ student_id }, { query }) {
  const url = get_api_path("student/mastery", query, { student_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function module({ student_id }, { query }) {
  const url = get_api_path("student/module", query, { student_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function routine({ student_id }, { query }) {
  const url = get_api_path("student/routine", query, { student_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function update_mastery({ student_id, mastery_level_id }) {
  const url = get_api_path("student/mastery/update", null, { student_id, mastery_level_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url);
  console.log(response.data.result);
}